import { LatestTransactionsTableTranslations } from ".";

export const LATEST_TRANSACTIONS_TABLE_EN_US: LatestTransactionsTableTranslations = {
	title: "Latest withdrawals and anticipations",
	date: "Request date",
	paymentDate: "Payment date",
	status: "Status",
	type: "Type",
	value: "Value",
	actions: "Actions",
	requester: "Requester",
	prorata: "Pro rata",
	refused: "Refused",
	pending: "Pending",
	canceled: "Canceled",
	paid: "Paid",
	processingCancellation: "Processing cancellation",
	processing: "Processing",
	pixProcessing: "PIX Processing",
	bankslipProcessing: "Processing Bankslip",
	pendingManagerApproval: "Pending manager approval",
	pendingPlaceConfirmation: "Pending place confirmation",
	canceledPlaceConfirmation: "Canceled place confirmation",
	pendingAnticipation: "Pending anticipation",
	pixKey: "PIX Key",
	reason: "Reason",
	requestReason: "Reason",
	refusalReason: "Refusal reason",
	favorecido: "Beneficiary",
	dataInicial: "Start date",
	dataFinal: "End date",
	at: "at",
	contaPropria: "Own account",
	placeDestino: "Destination place",
	beneficiarioBoleto: "Ticket beneficiary",
	back: "Back",
	withdrawal: "Withdrawal",
	anticipation: "Anticipation",
	detailsTitle: "Transaction details",
	filename: "withdrawals-anticipations-bankslips",
	// New bank account fields
	accountHolder: "Account Holder",
	accountType: "Account Type",
	agency: "Agency",
	account: "Account",
	bankName: "Bank Name",
	accountName: "Account Name",
	cancelWithdraw: "Cancel withdrawal",
	viewDetails: "View details",
	cancelConfirmTitle: "Cancel withdrawal",
	cancelConfirmDescription:
		"Are you sure you want to cancel this withdrawal? This action cannot be undone.",
	confirmCancel: "Yes, cancel",
	internalObservation: "Observations",
	table: {
		datetime: "Request date",
		paymentDate: "Payment date",
		type: "Type",
		status: "Status",
		username: "User",
		vendor: "Vendor",
		requestedValue: "Requested amount",
		liquidAnticipatedValue: "Anticipated amount",
		proRataFee: "Pro rata",
		appliedFee: "Applied fee",
		proRataFeeTooltip:
			"Anticipation fee proportional to the balance period to be anticipated",
		totalBruteValue: "Total gross amount",
		bankAccount: "Bank account",
		ticketPayment: "Boleto payment",
		clientObservation: "Reason",
		obs: "Observation",
		paymentMethod: "Payment method",
		attachments: "Attachments",
		confirmWithdrawBtnLabel: "Confirm request",
	},
	transactionLink: "Transaction link",
	filterByType: "Filter by type",
	allTypes: "All types",
	typeWithdraw: "Withdrawal",
	typeAnticipation: "Anticipation",
	typeTicketPayment: "Ticket payment",
	typeTransferBetweenPlaces: "Transfer between Places",
	// Translations for declined and related withdrawals
	viewOriginalWithdraw: "View original withdrawal",
	viewNewWithdraw: "View new withdrawal",
	originalWithdrawRequest: "Original Request",
	newWithdrawRequest: "New Request",
	withdrawDeclinedTitle: "Withdrawal Declined Due to Insufficient Balance",
	withdrawDeclinedMessage:
		"This withdrawal was automatically declined because the available balance was insufficient at the time of approval. If the account balance is greater than R$ 50.00, we will make a new request.",
	thisIsNewWithdraw:
		"This is the new withdrawal created after the original withdrawal was declined.",
	thisIsDeclinedWithdraw:
		"This withdrawal was declined and a new withdrawal was created.",
	retryPixReceipt: "Generate new receipt",
	retryPixReceiptSuccess: "Receipt generated successfully!",
	retryPixReceiptError: "Error generating new receipt",
	receiptNotAvailable: "Receipt not available",
};
